<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Edit event service</h2>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Service Name'"
          [type]="'text'"
          [placeholder]="'Enter service name'"
          [(value)]="service.event_service_name"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Available slots'"
          [type]="'number'"
          [placeholder]="'Enter available slots'"
          [(value)]="service.max_num_registrations"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'Service description'"
          [type]="'text'"
          [placeholder]="'Enter description name'"
          [(value)]="service.event_service_description"
        />
      </div>
    </div>
    <div class="row g-4">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Price'"
          [type]="'number'"
          [placeholder]="'Enter price'"
          [(value)]="service.price"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'Price currency'"
          [type]="'text'"
          [placeholder]="'Enter description name'"
          [disabled]="true"
          [(value)]="service.price_currency"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <app-button
      [variant]="'primary'"
      [size]="'md'"
      [label]="'Save Changes'"
      (clicked)="saveChanges()"
    />
  </div>
</div>
